import React, {Component} from 'react'
import PropTypes from 'prop-types'
import DavronFormErrorPage from './DavronFormErrorPage'
import DavronFormFirstPage from './DavronFormFirstPage'
import DavronFormSecondPage from './DavronFormSecondPage'
import DavronFormThirdPage from './DavronFormThirdPage'
import DavronFormFourthPage from './DavronFormFourthPage'
import DavronFormSubmissionPage from './DavronFormSubmissionPage'
import { CSSTransitionGroup } from 'react-transition-group'

class DavronForm extends Component {
	constructor(props) {
		super(props)
		this.nextPage = this.nextPage.bind(this)
		this.previousPage = this.previousPage.bind(this)
	}

	nextPage(values) {
		this.props.nextPage(values);
	}

	previousPage() {
		this.props.previousPage();
	}

	render() {
		const {onSubmit} = this.props
		const {page} = this.props
		return (
			<div>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={0}
				>

					{page === 0 &&<DavronFormErrorPage
						lng={this.props.lng}
						reloadForm={this.props.reloadForm}
					/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={0}
				>

					{page === 1 &&<DavronFormFirstPage
						lng={this.props.lng}
						onSubmit={this.nextPage}
						deliveryChange={this.props.deliveryChange}
					/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={0}
				>

					{page === 2 &&<DavronFormSecondPage
						lng={this.props.lng}
						previousPage={this.previousPage}
						onSubmit={this.nextPage}
						countries={this.props.formState.countries}
						requestOrigin={this.props.formState.translation_requestors}
						documentTypes={this.props.formState.official_documents}
						fromLang={this.props.formState.from_lang}
						toLang={this.props.formState.to_lang}
						certifications={this.props.formState.certifications}
						interpretingPurposes={this.props.formState.interpreting_purposes}
						interpretingTypes={this.props.formState.interpreting_types}
						durations={this.props.formState.durations}
						numberOfHours={this.props.formState.number_of_hours}
						levels={this.props.formState.levels}
						specialtyFields={this.props.formState.specialty_fields}
						serviceRequestClick={this.props.serviceRequestClick}
						filesAdded={this.props.filesAdded}
						uploadedFiles={this.props.uploadedFiles}
					/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={0}
				>

					{page === 3 &&
						<DavronFormThirdPage
							lng={this.props.lng}
							previousPage={this.previousPage}
							onSubmit={this.nextPage}
							countries={this.props.formState.countries}
							documents={this.props.formState.official_documents}
							certifications={this.props.formState.certifications}
							courierServices={this.props.formState.courier_services}
							sourceAvailable={this.props.formState.source_available}
							deliveryChange={this.props.deliveryChange}
							shippingAddressChange={this.props.shippingAddressChange}
							requestOrigin={this.props.formState.translation_requestors}
						/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={0}
				>

					{page === 4 &&
						<DavronFormFourthPage
							sameAddressChange={this.props.sameAddressChange}
							previousPage={this.previousPage}
							onSubmit={onSubmit}
							countries={this.props.formState.countries}
							lng={this.props.lng}
							coupon={this.props.coupon}
							referral_sources={this.props.formState.referral_sources}
						/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={0}
				>

					{page === 5 &&
						<DavronFormSubmissionPage
							opportunity={this.props.opportunity}
							lng={this.props.lng}
						/>}

				</CSSTransitionGroup>
			</div>
		)
	}
}

DavronForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
}

export default DavronForm


// WEBPACK FOOTER //
// ./src/DavronForm.js